import Taro from '@tarojs/api'
import { history } from '@tarojs/router'
import { isFunction } from '@tarojs/shared'

import { getApp, getCurrentInstance, getCurrentPages, navigateBack, navigateTo, nextTick, redirectTo, reLaunch, switchTab } from '../api'
import { permanentlyNotSupport } from '../utils'

const {
  Behavior,
  getEnv,
  ENV_TYPE,
  Link,
  interceptors,
  Current,
  options,
  eventCenter,
  Events,
  preload
} = Taro as any

const taro: typeof Taro = {
  // @ts-ignore
  Behavior,
  getEnv,
  ENV_TYPE,
  Link,
  interceptors,
  Current,
  getCurrentInstance,
  options,
  nextTick,
  eventCenter,
  Events,
  preload,
  history,
  navigateBack,
  navigateTo,
  reLaunch,
  redirectTo,
  getCurrentPages,
  switchTab
}

const requirePlugin = permanentlyNotSupport('requirePlugin')

function getConfig (): Record<string, any> {
  if (this?.pxTransformConfig) return this.pxTransformConfig
  return ((taro as any).config ||= {})
}

const initPxTransform = function ({
  designWidth = 750,
  deviceRatio = {
    640: 2.34 / 2,
    750: 1,
    828: 1.81 / 2
  } as TaroGeneral.TDeviceRatio,
  baseFontSize = 20,
  unitPrecision = 5,
  targetUnit = 'rem'
}) {
  const config = getConfig.call(this)
  config.designWidth = designWidth
  config.deviceRatio = deviceRatio
  config.baseFontSize = baseFontSize
  config.targetUnit = targetUnit
  config.unitPrecision = unitPrecision
}

const pxTransform = function (size = 0) {
  const config = getConfig.call(this)
  const baseFontSize = config.baseFontSize || 20
  const designWidth = (((input = 0) => isFunction(config.designWidth)
    ? config.designWidth(input)
    : config.designWidth))(size)
  if (!(designWidth in config.deviceRatio)) {
    throw new Error(`deviceRatio 配置中不存在 ${designWidth} 的设置！`)
  }
  const formatSize = ~~size
  let rootValue = 1 / config.deviceRatio[designWidth] * 2
  switch (config?.targetUnit) {
    case 'vw':
      rootValue *= 0.5 * designWidth / 100
      break
    default:
      rootValue *= baseFontSize
  }
  let val: number | string = formatSize / rootValue
  if (config.unitPrecision >= 0 && config.unitPrecision <= 100) {
    val = val.toFixed(config.unitPrecision)
  }
  return val + config?.targetUnit
}

const canIUseWebp = function () {
  const canvas = document.createElement('canvas')
  return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0
}

taro.requirePlugin = requirePlugin
taro.getApp = getApp
taro.pxTransform = pxTransform
taro.initPxTransform = initPxTransform
taro.canIUseWebp = canIUseWebp

export default taro

export {
  Behavior,
  canIUseWebp,
  Current,
  ENV_TYPE,
  eventCenter,
  Events,
  getEnv,
  history,
  initPxTransform,
  interceptors,
  Link,
  options,
  preload,
  pxTransform,
  requirePlugin
}
